
import * as actionTypes from "../constants/actionTypes";

export interface SetTagsAction {
  type: "SELECT_TAG";
  payload: { ids: Array<string> };
}

export type Action = SetTagsAction;

export function setTags(ids: Array<string>): Action {
  return {
    type: actionTypes.SELECT_TAG,
    payload: {
      ids
    }
  };
}
